(function($){
		$.extend({
        displayProgressBar : function(progressTitle, progressText, indefinite, domElement, transition, wrapperElement) {
            transitioningDOMElement = domElement;
            transitionType = transition;
            
            var loadingOverlay = $('.loading-overlay')[0];
            
            if (!loadingOverlay) {
                if (!progressText) {
                	progressText = '';
                }
                
                if (!!wrapperElement) {
                	$.debugLog("Loading progress bar in wrapper");
                	var loadingHTML = '<div class="progress-bar-container"><div class="progress-bar"><div class="progress-bar-text-container"><div class="progress-text">' + progressText + '</div></div></div><div class="progress-text-container"><div class="progress-text">' + progressText + '</div></div></div>';
                	$(wrapperElement).append(loadingHTML);
                	progressText = $(wrapperElement).find('.progress-text');
                	var progressBarContainer = $(wrapperElement).find('.progress-bar-container');
                    var progressBar = $(wrapperElement).find('.progress-bar');
                    var progressBarTextContainer = $(wrapperElement).find('.progress-bar-text-container');
                    var progressTextContainer = $(wrapperElement).find('.progress-text-container');
                    
                    progressBarContainer.css({
                    	'position': 'relative',
                    	'overflow': 'hidden',
                    });
                    progressTextContainer.css({
                    	'position': 'absolute',
                    	'top': '0',
                    	'left': '0',
                    	'padding': '0px',
                    	'z-index': '2',
                    	'color': 'black'
            		});
                    progressBarTextContainer.css({
                    	'position': 'absolute',
                    	'top': '0',
                    	'left': '0',
                    	'padding': '0px',
                    	'z-index': '1',
                    	'color': 'white',
                    	'text-align' : 'center',
                    	'font-size' : '14px',
                    	'font-style' : 'italic'
            		});
                    progressBar.css({
                    	'position': 'relative',
                    	'overflow': 'hidden',
                    	'z-index': '3'
                    });
                } else {
                	var loadingOverlayHTML = '<div class="loading-overlay" style="display: none;"><div class="progress-title">' + progressTitle + '</div><div class="progress-bar-container"><div class="progress-bar"></div></div><div class="progress-text-container"><span class="progress-text">' + progressText + '</span></div></div>';
                    $('body').append(loadingOverlayHTML);
                    loadingOverlay = $('.loading-overlay');
                    progressTitle = $('.progress-title');
                    progressText = $('.progress-text');
                    var progressBarContainer = $('.progress-bar-container');
                    var progressBar = $('.progress-bar');
                    var progressTextContainer = $('.progress-text-container');
                    
                    progressTitle.css({
                        'margin-bottom' : '20px',
                    	'line-height' : 'normal',
                    	'font-size' : '16px',
                        'font-weight' : 'bold',
                    	'background-color' : '#009CDE',
                        'color' : 'white',
                        'padding' : '7px',
                    	'border-radius' : '7px 7px 0px 0px',
                        'text-align' : 'center'
                    });
                    
                    loadingOverlay.css({
                    	'text-align' : 'center',
                        'width' : '400px',
                        'background-color' : '#FFFFFF',
                        'font-size': '18px',
                        'position': 'fixed', 
                        'border' : 'none',
                        'vertical-align' : 'middle',
                        'line-height' : '1px',
                        'box-shadow' : '0px 0px 50px 5px rgba(0, 0, 0, .35)',
                    	'border-radius' : '10px 10px 7px 7px',
                        // this z-index is necessary because GWT is ridiculous
                        'z-index' : '1000000'
                    });
                    
                    loadingOverlay.css({
                        'top': ($(window).height() - loadingOverlay.outerHeight()) / 2, 
                        'left': ($(window).width() - loadingOverlay.outerWidth()) / 2
                    });
                    
                    progressTextContainer.css({
                    	'padding' : '10px'
                    });
                }
                 
                progressBarContainer.css({
                    'background-color' : 'transparent',
                    'height' : '26px',
                    'width' : '95%',
                    'border' : '1px solid #004987',
                    'overflow' : 'hidden',
                    'display' : 'inline-block',
                	'text-align' : 'center',
                	'border-radius' : '3px'
                });
                
                progressBar.css({
                    'background-color' : '#009CDE',
                    'height' : '100%',
                    'width' : '0'                    
                });
                
                progressTextContainer.css({
                    'text-align' : 'center',
                	'font-size' : '14px',
                	'font-style' : 'italic'
                });
                
                progressText.css({
                	'height' : '25px',
	                'line-height' : '25px',
	                'display' : 'block',
	                'overflow' : 'hidden',
	                'white-space' : 'nowrap',
	                'text-overflow' : 'ellipsis',
	                'text-align' : 'center'
                });
               
                if(!wrapperElement) {
	                loadingOverlay.fadeIn(250);
	                var screenOverlayHTML = '<div class="progress-widget-overlay"></div>';
	                $('body').append(screenOverlayHTML);
	                var screenOverlay = $('.progress-widget-overlay');
                
	                screenOverlay.css({
	                    'position' : 'fixed',
	                    'top' : '0',
	                    'left' : '0',
	                    'background' : '#000000',
	                    'opacity' : '0.5',
	                    'width' : $(window).width(),
	                    'height' : $(window).height(),          
	                    // this z-index is necessary because GWT is ridiculous
	                    'z-index' : '999990'
	                });
                }
            }
        },
        displayLoopProgressBar : function(progressTitle, progressText, domElement, transition) {
            $.displayProgressBar(progressTitle, progressText, true, domElement, transition);
            $.loopProgressBar();
        },
        updateProgressBar: function(percentage, container){
        	if(!!container){
	        	$(container).find('.progress-bar').css({
	        		'width' : percentage + '%'
	        	});
        	} else {
        		$('.progress-bar').css({
	        		'width' : percentage + '%'
	        	});
        	}
        },
        loopProgressBar: function(){
        	
        	var base64Background = 'R0lGODlhKAAoAIABAAAAAP///yH/C05FVFNDQVBFMi4wAwEAAAAh+QQJAQABACwAAAAAKAAoAAACkYwNqXrdC52DS06a7MFZI+4FHBCKoDeWKXqymPqGqxvJrXZbMx7Ttc+w9XgU2FB3lOyQRWET2IFGiU9m1frDVpxZZc6bfHwv4c1YXP6k1Vdy292Fb6UkuvFtXpvWSzA+HycXJHUXiGYIiMg2R6W459gnWGfHNdjIqDWVqemH2ekpObkpOlppWUqZiqr6edqqWQAAIfkECQEAAQAsAAAAACgAKAAAApWMH6C76MbiQ5FNWtWFGWyefZ0ndmV4Vqm0Wtv4JeY706jN4vlV8/30e8BaGmJR1zCSkEffzbkDBh1TzFOqUsaG0KiwCsoym99rWYxFp71W9Zl94HZd8+R4uabXyVRwGP6nl2c3yNdndggYSFi45SfjlqgIOSnXqGXkiNgm+NYpyegZCmrI+Wk6GvdoSVqqurnoGrtUAAAh+QQJAQABACwAAAAAKAAoAAAClYx/oLvoxuJDkU1a1YUZbJ59nSd2ZXhWqbRa2/gF8Gu2DY3iqs7yrq+xBYEkYvFSM8aSSObE+ZgRl1BHFZNr7pRCavZ5BW2142hY3AN/zWtsmf12p9XxxFl2lpLn1rseztfXZjdIWIf2s5dItwjYKBgo9yg5pHgzJXTEeGlZuenpyPmpGQoKOWkYmSpaSnqKileI2FAAACH5BAkBAAEALAAAAAAoACgAAAKXjI8By5zf4kOxTVrXNVlv1X0d8IGZGKLnNpYtm8Lr9cqVeuOSvfOW79D9aDHizNhDJidFZhNydEahOaDH6nomtJjp1tutKoNWkvA6JqfRVLHU/QUfau9l2x7G54d1fl995xcIGAdXqMfBNadoYrhH+Mg2KBlpVpbluCiXmMnZ2Sh4GBqJ+ckIOqqJ6LmKSllZmsoq6wpQAAAh+QQJAQABACwAAAAAKAAoAAAClgSCqWHtC92DSk6KrMFJb854oHeMIkeCoWayrfVKaoqetYvRN7zL8UXR5WxBYhF35PWAEWMTmWQ+lUNqVLpwZrUV6NS3/ITFVXDZfCWn1d/GjNvxbuVdegZ+t6+sbfe49PfjF0hYuAZ4hhWnt4c2x/foWAc5KblIeWmZh7mp2TmYCLr2xojXqJgp2scWqdrqWgmbKvtZAAAh+QQJAQABACwAAAAAKAAoAAACkoQRqRvnxuI7kU1a1UU5bd5tnSeOZXhmn5lWK3qNTWvRdQxP8qvaC+/yaYQzXO7BMvaUEmJRd3TsiMAgswmNYrSgZdYrTX6tSHGZO73ezuAw2uxuQ+BbeZfMxsexY35+/Qe4J1inV0g4x3WHuMhIl2jXOKT2Q+VU5fgoSUI52VfZyfkJGkha6jmY+aaYdirq+lQAACH5BAkBAAEALAAAAAAoACgAAAKYhB+pG+fG4kNxTVrTBVlt3jVXKI7hRn6p2aknm7ktOsOVfNP19NqSnvMxcD+hBVjk9ZQxZPKxhEYdU0zTqHEOtR5uF5tlXsVB6c48plYh6xW4hC7Hn1a5+lyn57dkPRv/l3YnuPfVx3doOIe4qDhoVxiW6BgJ10gZ6AcCmMn4qLm2Sdh59EbkWWn5WTopeemaeooqCkl6VAAAIfkECQEAAQAsAAAAACgAKAAAApaEb6HLgd/iO7FNWtcFWe+ufODGjRfoiJ2akShbueb0wtI50zm02pbvwfWEMWBQ1zKGlLIhskiEPm9R6vRXxV4ZzWT2yHOGpWMyorblKlNp8HmHEb/lCXjcW7bmtXP8Xt229OVWR1fod2eWqNfHuMjXCPkIGNileOiImVmCOEmoSfn3yXlJWmoHGhqp6ilYuWYpmTqKUgAAIfkECQEAAQAsAAAAACgAKAAAApUMjhjLbZmcg1E2qizDQG/uLWDIdSQWPuhJpaW7ei8LwbE2yjl+W7PeotWEFV5P8vPtlMfLEvl0NqVBY9U6xBa1Ge7BdoVOP2NVWHymZr0mNnjNhKPlk7KZru66iV9+H4hHlpb3twe4FRcoYpeUqOf4OIdYxxglqHg3SVgIyUk5eKkZGvmp2ChJOupZKrpYWXbKmhpQAAAh+QQBAQABACwAAAAAKAAoAAAClIyBmcZ9qpyDUTa67MOaYdQFHxCKX3mGI8qpafdqq0uxLXzLsbVLM16jBYEQ21B35PUmS0/TmfM9N0lmVHq9TE1ZaNX69RaFY2RYXDGX1WllF51hx+Ug4tp9prbxd2wf/KeVxzW49UNnFAhHQrbn5wgIKaioJ7mYaFk595hJSHnIlwnKuRlZalpHx2gnajg1irraUAAAOw==';
        	
        	$('.progress-bar-container').css({
        		'background-color' : '#009CDE'
        	});
        	
        	$('.progress-bar').css({
        	    'width' : '100%',
        	    'background-color': 'transparent',
        		'background-image' : "url('data:image/png;base64," + base64Background + "')",
        		'opacity': '0.5'
        	});
        },
        displayAnimatedLogo : function(text, domElement, wrapperSelector) {
            if (!!text && text.length > 0) {
                text = text.split('...')[0];
            } else {
                text = '';
            }
            
            transitioningDOMElement = domElement;
            
            if (!wrapperSelector) {
                wrapperSelector = '.animated-loading-wrapper';
            }
            
            var textSelector = wrapperSelector + ' ' + '.animated-text';
            var logoSelector = wrapperSelector + ' ' + '.animated-logo-wrapper';
            
            if (!domElement)
            {
                var $loadingOverlay = $('.animated-logo-wrapper');
                var $textLogoWrapper = $('.text-logo-wrapper');
                
            	var overlayHeight = $('body')[0].scrollHeight;
                var textLogoWrapperHeight = $('.text-logo-wrapper').height();       
                var viewPortHeight = $(window).scrollTop() + $(window).height() / 2;
                
                $loadingOverlay.css('height', overlayHeight - 52);
                $textLogoWrapper.css('top', viewPortHeight - textLogoWrapperHeight);
            }
            
            $(textSelector).html(text);
            $(logoSelector).show();
        },
        removeAnimatedLogo : function() {
            try{
                if (transitioningDOMElement) {
                    $(transitioningDOMElement).fadeIn(250);
                }
            }
            catch(e){
            }
            
            $('.animated-logo-wrapper').hide();
            $('.animated-text').html('');
        },
        removeProgressBar : function(container) {
        	try{
                if (transitioningDOMElement) {
                    if (transitionType === 'opacity') {
                        $(transitioningDOMElement).animate({opacity : '1.0'}, 250);
                    } else {
                        $(transitioningDOMElement).fadeIn(250);
                    }                
                }
        	}
            catch(e){
            	
            }
        	
            if(!!container) {
            	$(container).find('.progress-bar-container').remove();
            } else {
	        	$('.progress-widget-overlay').remove();
	            $('.loading-overlay').remove();
            }
        }
    });
})(jQuery);